import _ from "lodash";

const initialState = {
  activeStreams: [] as {
    channelId: string;
    hostId: string;
    hostName: string;
    token?: string;
  }[],

  showLiveHostModal: false,
  showLiveViewModal: false,
  showLiveViewer: null,
  entity: null,
  isHostLiveMinimized: false,
  isViewLiveMinimized: false,
};

const liveStreamReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "ADD_LIVE_STREAM":
      return {
        ...state,
        activeStreams: _.uniqBy(
          [...state.activeStreams, action.payload],
          "channelId",
        ),
      };

    case "REMOVE_LIVE_STREAM":
      return {
        ...state,
        activeStreams: state.activeStreams.filter(
          (x) => x.channelId !== action.payload,
        ),
      };

    case "CLEAR_LIVE_STREAMS":
      return {
        ...state,
        activeStreams: [],
      };

    case "SET_SHOW_LIVE_HOST_MODAL":
      return {
        ...state,
        showLiveHostModal: action.payload,
      };

    case "SET_SHOW_LIVE_VIEW_MODAL":
      return {
        ...state,
        showLiveViewModal: action.payload,
      };

    case "SET_SHOW_LIVE_VIEWER":
      return {
        ...state,
        showLiveViewer: action.payload,
      };

    case "SET_LIVE_ENTITY":
      return {
        ...state,
        entity: action.payload,
      };

    case "SET_HOST_LIVE_MINIMIZED":
      return {
        ...state,
        isHostLiveMinimized: action.payload,
      };

    case "SET_VIEW_LIVE_MINIMIZED":
      return {
        ...state,
        isViewLiveMinimized: action.payload,
      };

    default:
      return state;
  }
};

export default liveStreamReducer;
